
import { Button, styled } from '@mui/material'
import React from 'react';

interface ButtonProps {
    btnText: string;
    sx?: React.CSSProperties;
    onClick: () => void
    disabled?: boolean
}

const StyledBtn = styled(Button)(() => ({
    backgroundColor: "#000",
    border: "1px solid #000",
    color: "#fff",
    padding: "6px 20px",
    "&.Mui-disabled": {
      backgroundColor: "#ccc", // Set the background color when disabled
      color: "#888", // Set the text color when disabled
      border: "1px solid #ccc", // Adjust border color when disabled
    },

}))

const BlackButtonComponent = ({btnText, sx, onClick, disabled}: ButtonProps) => {
  return (
    <StyledBtn onClick={onClick} disabled={disabled} sx={sx}>{btnText}</StyledBtn>
  )
}

export default BlackButtonComponent